import { getPaletteColor } from "theme/helpers";

const Styles = {
  defaultChip: {
    ".MuiChip-label": {
      fontSize: "13px",
      lineHeight: "18px",
      letterSpacing: "0.16px",
      p: "7px 10px",
    },

    "&.Mui-disabled": {
      backgroundColor: getPaletteColor("action.disabled"),
    },
  },
};

export default Styles;
